module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.opened) ? _c('div', {
    staticClass: "contents"
  }, [_c('div', {
    staticClass: "scroll-height"
  }, [_vm._l((_vm.uniqueTypesList), function(type) {
    return _c('list-option', {
      key: type.id,
      attrs: {
        "main-text": type.name,
        "disabled": !(type.isValid && type.selectable)
      },
      on: {
        "selected": function($event) {
          _vm.selectType(type)
        },
        "unselected": function($event) {
          _vm.unselectType(type)
        }
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "width-100 fixed-bottom flex-v-center flex-justify-right padding-v-half clickable",
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_c('span', {
    staticClass: "font-14 padding-r-half"
  }, [_vm._v("Continue")]), _vm._v(" "), _c('svg', {
    staticClass: "padding-r-1-em",
    attrs: {
      "width": "8px",
      "height": "15px"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0 L8 7.5 L0 15 L0 13.5 L6.5 7.5 L0 1.5"
    }
  })])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-016d4e14","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/linkedTypeStage.vue
// module id = 579
// module chunks = 0